/**
 * Budget Settings Header Container
 *
 * Provides breadcrumb navigation and tab navigation for Budget Settings pages
 * Follows the pattern from ProjectInsightsHeader with ContentHeader component
 */

import React from 'react'
import { useHistory } from 'react-router-dom'
import { Header, Image, Grid } from 'semantic-ui-react'
import { ContentHeader } from '../../../components/Header/ContentHeader'
import back from '../../../assets/svg/back_arrow.svg'

const BudgetSettingsHeaderContainer = (): JSX.Element => {
  const history = useHistory()

  const handleBackClick = () => {
    history.push('/budget')
  }

  // Custom breadcrumb element matching "Insights / Project" pattern
  const breadcrumbElement = (
    <Grid.Row style={{
      fontSize: '31.5px',
      fontWeight: 500,
      cursor: 'pointer',
      color: '#172533',
      letterSpacing: '.25px',
      display: 'flex',
      alignItems: 'center',
      marginTop: '20px',
      marginBottom: '20px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }} onClick={handleBackClick}>
        <Image src={back} style={{ width: '13px', height: '10px' }} />
        <Header.Subheader style={{ marginLeft: '.5rem' }}>
          Study Budgeting
        </Header.Subheader>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Header.Subheader style={{ marginLeft: '.5rem', color: '#08D6A1' }}>
          /
        </Header.Subheader>
        <Header.Subheader style={{ marginLeft: '.5rem', color: '#08D6A1' }}>
          Settings
        </Header.Subheader>
      </div>
    </Grid.Row>
  )

  return (
    <ContentHeader
      title={<></>}
      color='#08D6A1'
      backButton={breadcrumbElement}
    />
  )
}

export default BudgetSettingsHeaderContainer
